import { IconFn, IconSvg } from "../createIcon";

export const PlusIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 48, height: 48 }} {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M20.7143 44V5H26.2857V44H20.7143Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M4 21.7143H43V27.2857H4V21.7143Z" fill={color} />
  </IconSvg>
);
